/**
 * Asisten AI (CS) Constants
 *
 * PENTING: File ini harus SINKRON dengan:
 * - Backend: Booku.Domain/Constants/AsistenConstants.cs
 *
 * Rencana: .claude/docs/Booku v2/02-features/asisten-ai-cs.md
 */

// ============================================
// JENIS PERISTIWA ALIRAN (Server-Sent Events dari POST /api/asisten/pesan)
// ============================================

/** Potongan teks jawaban. */
export const PeristiwaAsisten_Teks = 'teks';
/** Asisten sedang memakai alat (mis. mencari di panduan). */
export const PeristiwaAsisten_Alat = 'alat';
/** Tiket eskalasi dibuat — membawa tautan wa.me. */
export const PeristiwaAsisten_Tiket = 'tiket';
/** Jawaban selesai — membawa id percakapan, id pesan, dan sumber panduan. */
export const PeristiwaAsisten_Selesai = 'selesai';
/** Gagal menjawab — membawa pesan untuk user. */
export const PeristiwaAsisten_Galat = 'galat';

export type JenisPeristiwaAsisten =
  | typeof PeristiwaAsisten_Teks
  | typeof PeristiwaAsisten_Alat
  | typeof PeristiwaAsisten_Tiket
  | typeof PeristiwaAsisten_Selesai
  | typeof PeristiwaAsisten_Galat;

// ============================================
// PERAN PESAN
// ============================================

export const PeranAsisten_User = 'user';
export const PeranAsisten_Assistant = 'assistant';

export type PeranPesanAsisten = typeof PeranAsisten_User | typeof PeranAsisten_Assistant;

// ============================================
// RATING JAWABAN
// ============================================

export const RatingAsisten_Suka = 1;
export const RatingAsisten_TidakSuka = -1;

// ============================================
// BATAS (cermin bawaan backend — validasi akhir tetap di server)
// ============================================

/** Panjang maksimal satu pesan (Asisten:MaksPanjangPesan di appsettings.json). */
export const MaksPanjangPesanAsisten = 2000;

/** Panjang maksimal alasan 👎 (AsistenConstants.MaksPanjangAlasanRating / kolom Alasan_Rating). */
export const MaksPanjangAlasanRatingAsisten = 500;
